export const environment = {
    production: false,
    appName: "Pandora",
    appVersion: "1.0",
    baseUrl: "https://incloud-static.roboze.com/",
    notificationService: {
        cookieKey: "none",
        baseUrl: "https://workingnotifications.roboze.com/api_v1/"
    },
    farmer: false,
    privacyPolicy: {
        url: "https://roboze.com/privacy-policy/"
    },
    redirectTo: {
        cookieKey: "redirectTo",
        url: "https://workingid.roboze.com/auth/login",
        domain: ".roboze.com"
    },
    inCloud: {
        baseUrl: "https://traktor.roboze.com/"
    },
    support: {
        downloadUrl: "https://support.roboze.com/downloads/"
    },
    payments: {
        baseUrl: "http://payments.staging.roboze.com/api_v1/",
        redirectCookieKey: "back_url",
        domain: ".roboze.com"
    },
    streamServer: {
        url: "https://stream.roboze.com/hls/",
        streamTimeout: 900
    },
    googleDriveAuth: {
        clientId: "276073670923-l3o3eguh6puhpakm8l655p7086bdcdib.apps.googleusercontent.com",
        scope: "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file",
        secureRoutes: ["https://traktor.roboze.com/api/googleDrive"]
    },
    roboze:{
      url:"https://www.roboze.com"
    }
};
